const Mn = require('backbone.marionette');

module.exports = Mn.Behavior.extend({
    ui: {
        navToggle: '.nav-toggle'
    },
    events: {
        'click @ui.navToggle': 'toggleNav'
    },

    onDomRefresh: function() {
        this._openWidth = $('#nav').width();

        if ($('#nav').hasClass('is-hidden')) {
            $('#nav').css('width', '0');
            $('.nav-toggle-icon').addClass('is-inactive');
        }
    },

    toggleNav: function() {
        if ($('#nav').hasClass('is-hidden')) {
            this.open();
        }
        else {
            this.close();
        }
    },

    open: function() {
        const width = this._openWidth / $(window).width() * 100;

        $('#nav').animate({
            width: `${width}%`
        }, 300)
            .queue(function() {
                $('#nav').css('width', '').dequeue();
            })

        $('#nav').removeClass('is-hidden');
        $('.nav-toggle-icon').removeClass('is-inactive');
    },

    close: function() {
        this._openWidth = $('#nav').width();

        $('#nav').animate({
            width: 0
        }, 300);

        $('#nav').addClass('is-hidden');
        $('.nav-toggle-icon').addClass('is-inactive');
    }
});



// WEBPACK FOOTER //
// ./common/ui/view/behavior/togglenav.js